import React from 'react';
import { detectMobile } from 'utils/UiHelper';

const MobileFormWrapper = (props) => {
    const {
        onSubmit,
        submitInputStyles,
        children,
        inputBlurOnSubmit,
        ...rest
    } = props;

    if (!detectMobile()) {
        return children;
    }

    function submitHandler(event) {
        event.preventDefault();

        if (inputBlurOnSubmit) {
            const focusedInput = document.querySelector('input:focus');
            if (focusedInput && typeof focusedInput.blur === 'function') {
                focusedInput.blur();
            }
        }

        onSubmit(event);
    }

    return (
        <form {...rest} onSubmit={submitHandler}>
            {children}
            <input type="submit" style={submitInputStyles} />
        </form>
    );
};

MobileFormWrapper.defaultProps = {
    submitInputStyles: {
        overflow: 'hidden',
        width: 0,
        height: 0,
        border: 0,
        display: 'none',
    },
    inputBlurOnSubmit: false,
    onSubmit: () => {},
};

export default MobileFormWrapper;
